import { z } from "zod";
/**
 * A screen the web app showed, and for how long it was visible: what it sends
 * to `POST /api/workspaces/{workspaceId}/usage/views` as each screen is left.
 * The server checks the same limits (`server/crates/api/src/modules/usage`).
 */
export const usageViewSchema = z.object({
    /** `ScreenKind` in the web app, or `setup` while the wizard has the window. */
    screen: z
        .string()
        .min(1)
        .max(40)
        .regex(/^[a-z][a-zA-Z0-9-]*$/u),
    /** One stretch of use in one tab; a new one after 30 idle minutes. */
    visitId: z
        .string()
        .min(8)
        .max(64)
        .regex(/^[0-9a-fA-F-]+$/u),
    /** Visible time only: a hidden tab is not someone reading. At most 6 hours. */
    activeMs: z.number().int().min(0).max(21_600_000),
    /** The short commit the bundle was built from; absent in a local build. */
    release: z
        .string()
        .min(1)
        .max(40)
        .regex(/^[A-Za-z0-9._-]+$/u)
        .optional(),
});
export const usageViewsBodySchema = z.object({
    views: z.array(usageViewSchema).min(1).max(20),
});
//# sourceMappingURL=usage.js.map